<template>
	<page-container class="container no-heading-image" :page="page">
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<template #extra-content>
				<div class="columns column12">
					<recursive-sitemap :items="sitemap" />
				</div>
			</template>
		</main-content>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>

<style lang="scss" scoped>
.close-button {
	position: absolute;
	top: 50px;
	right: 50px;
	left: auto;
	bottom: auto;
	font-size: 40px;
	z-index: 4;
}
</style>
